import styles from './SellersBeforeTable.module.scss';
import cn from 'classnames';
import { BeforeProps } from '@containers/DataTable';
import { Button, ButtonType } from '@components/Button';
import { Seller } from '@api/apiClient';
import { Text, TextSize } from '@components/Text';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSellersCounter } from '@contexts/SellersCounterContext';

interface SellersBeforeTableProps<T, Params = void> extends BeforeProps<T, Params> {
  title: string;
}

const SellersBeforeTable = <T, Params = void>(props: SellersBeforeTableProps<T, Params>) => {
  const { isLoading, title } = props;

  const [showAllSellers, setShowAllSellers] = useState<boolean>(false);

  const navigate = useNavigate();
  const numberVisibleSellers = 9;
  const { sellersList } = useSellersCounter();
  const { t } = useTranslation();

  const dataSellers: Seller[] = sellersList.filter((item: Seller) => !item.apiClientId);

  if (!isLoading) {
    if (dataSellers && dataSellers.length > 0) {
      return (
          <div className={cn(styles.inner, styles.innerRed)}>
            <Text size={TextSize.M}>
              <b>
                {title}
              </b>
            </Text>
            <div className={styles.list}>
              {dataSellers.map((item: Seller, index: number) => {
                if (showAllSellers || index < numberVisibleSellers) {
                  return (
                      <span
                          className={styles.listItem}
                          key={index}
                      >
                        <Text
                            ellipsis
                            key={index}
                            size={TextSize.M}
                            width="100%"
                        >
                          — {item.name}
                        </Text>
                      </span>
                  );
                }
              })}
              {dataSellers.length > numberVisibleSellers && (
                  <Button
                      key="action"
                      onClick={() => setShowAllSellers(!showAllSellers)}
                      title={`...${t(`sellersBeforeTable.${showAllSellers ? 'hide' : 'more'}`)}`}
                      type={ButtonType.LINK}
                  />
              )}
            </div>
            <Button
                onClick={() => navigate('/profile?tab=storeTab')}
                title={t('sellersBeforeTable.btn')}
                type={ButtonType.RED_SKELETON}
            />
          </div>
      );
    }
  }
  return null;
};

export default SellersBeforeTable;